export const OFFERINGS = [
  {
    label: "Adventure",
    title: "Thrilling Water Sports & Scuba Diving",
    desc: "Feel the adrenaline rush with activities like jet skiing, parasailing, and scuba diving, perfect for thrill-seekers exploring the Goan coastline.",
    rank: 1,
    img: "/images/around-us/01",
  },
  {
    label: "Relaxation",
    title: "Luxury Yacht Cruises & Sunset Sails",
    desc: "Sail across the Arabian Sea on a luxury yacht, soaking in breathtaking sunsets and enjoying a peaceful retreat on the waters.",
    rank: 2,
    img: "/images/around-us/02",
  },
  {
    label: "Bars",
    title: "Hidden Speakeasy & Concept Bars",
    desc: "Discover hidden speakeasy bars and unique concept bars, offering signature cocktails, live music, and a one-of-a-kind nightlife experience.",
    rank: 3,
    img: "/images/around-us/03",
  },
  {
    label: "Forts",
    title: "Walk Through Goa’s Historic Forts",
    desc: "Step into history with centuries-old forts offering stunning sea views, Portuguese-era architecture, and a glimpse into Goa’s rich past.",
    rank: 4,
    img: "/images/around-us/04",
  },
  {
    label: "Wellness & Spirituality",
    title: "Rejuvenate with Yoga & Wellness Retreats",
    desc: "Unwind your body and mind with guided yoga sessions, spa treatments, and meditation retreats set amidst Goa’s tranquil surroundings.",
    rank: 5,
    img: "/images/around-us/05",
  },
  {
    label: "Culinary",
    title: "Global Cuisines & Goan Food Trails",
    desc: "Embark on a exotic culinary journey with global fusion & Goan delicacies, guided food trails, and local market tours that celebrate the region’s rich flavors.",
    rank: 6,
    img: "/images/around-us/06",
  }
];